import {
  AmpStandaloneResponse,
  CompleteOpportunitiesRequest,
  CompleteOpportunitiesResponse,
  ConsumerInsightsRowsRequest,
  ConsumerInsightsRowsResponse,
  CxmEnvironmentValues,
  DealInsightsRecordsEntity,
  DealInsightsRowsRequest,
  DealInsightsRowsResponse,
  OpportunitiesInsightsRowsRequest,
  OpportunitiesRowsRequest,
  OpportunitiesRowsResponse,
  OpportunityInsightsRowsResponse,
  UserProfileResponse
} from "@coxauto-ui/cxm/interfaces";
import { fetchWrapper } from "@coxauto-ui/core/http";
import authClient from "@coxauto-ui/core/auth/get-auth-client-crw";
import { getEnvConfig } from "@coxauto-ui/core/get-env";

const { BASE_URL: baseUrl } = getEnvConfig<CxmEnvironmentValues>("cxm");

export async function getUserProfile(viewAsUsername: string) {
  const path = `${baseUrl}api/user-profile${
    viewAsUsername !== "" ? `?actingUserName=${viewAsUsername}` : ""
  }`;

  const bridgeJwt = await authClient.getAuth();

  const response = await fetchWrapper.getAsync<UserProfileResponse>(path, {
    Authorization: `Bearer ${bridgeJwt}`
  });

  if (!response.data) {
    return Promise.reject(response.error);
  }
  if (response.hasError) {
    return Promise.reject({
      ...response.error,
      message: response.data?.message
    });
  }
  return Promise.resolve(response.data);
}

export async function getConsumerInsightsRows(
  request: ConsumerInsightsRowsRequest
) {
  const bridgeJwt = await authClient.getAuth();

  const response = await fetchWrapper.postAsync<any>(
    `${baseUrl}api/deal/rows`,
    request,
    { Authorization: `Bearer ${bridgeJwt}` }
  );

  if (!response.data || response.hasError) {
    return Promise.reject(response?.data?.message || response.error);
  }

  const data: ConsumerInsightsRowsResponse = response.data;

  return data;
}

export async function getOpportunitiesRows(request: OpportunitiesRowsRequest) {
  const bridgeJwt = await authClient.getAuth();

  const response = await fetchWrapper.postAsync<any>(
    `${baseUrl}api/opportunities/rows`,
    request,
    { Authorization: `Bearer ${bridgeJwt}` }
  );

  if (!response.data || response.hasError) {
    return Promise.reject(response?.data?.message || response.error);
  }

  const data: OpportunitiesRowsResponse = response.data;

  return data;
}

export async function completeOpportunities(
  request: CompleteOpportunitiesRequest
) {
  const bridgeJwt = await authClient.getAuth();

  return await fetchWrapper.postAsync<CompleteOpportunitiesResponse>(
    `${baseUrl}api/opportunity/complete`,
    request,
    {
      Authorization: `Bearer ${bridgeJwt}`,
      "Content-Type": "application/vnd.coxauto.v2+json"
    }
  );
}

export async function getIsAmpStandalone(consumerId: string) {
  const bridgeJwt = await authClient.getAuth();

  return await fetchWrapper.getAsync<AmpStandaloneResponse>(
    `${baseUrl}api/opportunity/amp-standalone?consumerId=${consumerId}`,
    {
      Authorization: `Bearer ${bridgeJwt}`,
      "Content-Type": "application/vnd.coxauto.v2+json"
    }
  );
}

export async function getDealInsightsRows(request: DealInsightsRowsRequest) {
  const bridgeJwt = await authClient.getAuth();

  const response = await fetchWrapper.postAsync<any>(
    `${baseUrl}api/deal/rows`,
    request,
    {
      Authorization: `Bearer ${bridgeJwt}`,
      "Content-Type": "application/vnd.coxauto.v2+json"
    }
  );

  if (!response.data || response.hasError) {
    return Promise.reject(response?.data?.message || response.error);
  }

  const data: DealInsightsRowsResponse = response.data;

  return data;
}

export async function getDealById(dealId: string) {
  const bridgeJwt = await authClient.getAuth();

  const response = await fetchWrapper.getAsync<DealInsightsRecordsEntity>(
    `${baseUrl}api/deal/${dealId}`,
    {
      Authorization: `Bearer ${bridgeJwt}`,
      "Content-Type": "application/vnd.coxauto.v2+json"
    }
  );

  if (!response.data || response.hasError) {
    return Promise.reject(response.error);
  }

  return response.data;
}

export async function getMultiDealInsights(consumerId: string) {
  const bridgeJwt = await authClient.getAuth();

  const response = await fetchWrapper.getAsync<any>(
    `${baseUrl}api/deal/multi-view?consumerId=${consumerId}`,
    {
      Authorization: `Bearer ${bridgeJwt}`,
      "Content-Type": "application/vnd.coxauto.v2+json"
    }
  );

  if (!response.data || response.hasError) {
    return Promise.reject(response?.data?.message || response.error);
  }

  const data: DealInsightsRecordsEntity[] = response.data;

  return data;
}

export async function getOpportunityInsightsRows(
  request: OpportunitiesInsightsRowsRequest
) {
  const bridgeJwt = await authClient.getAuth();

  const response = await fetchWrapper.postAsync<any>(
    `${baseUrl}api/opportunity/rows`,
    request,
    {
      Authorization: `Bearer ${bridgeJwt}`,
      "Content-Type": "application/vnd.coxauto.v2+json"
    }
  );

  if (!response.data || response.hasError) {
    return Promise.reject(response?.data?.message || response.error);
  }

  const data: OpportunityInsightsRowsResponse = response.data;

  return data;
}
